<!-- ------------------------Компонент для редагування пошти ----------------------------------- -->
<template>
  <smallModal @escape="$emit('close')">
    <h5>{{ lang['Edit'] }}: {{ personEmail }}?</h5>
    <hr>
    <div v-if="personPassword">
      <label for="new-email">{{ lang['NewEmail'] }}</label>
      <b-form-input v-model="new_email" autofocus id="email-input-settings" :state="checkEmail" />
    </div>
    <div v-else class="center-text">
      <span class="grey-span">{{ lang['FirstCreateAnAccountPassword'] }}</span>
    </div>
    <hr>
    <div class="buttons">
      <button class="btn btn-secondary" @click="$emit('close')">{{ lang['Сancel'] }}</button>
      <button v-if="personPassword" class="btn btn-success" @click="editEmail">{{ lang['Proceed'] }}</button>
      <button v-else class="btn btn-success" @click="goAddPass">{{ lang['Proceed'] }}</button>
    </div>
    <!-- этот див для автофокуса, чтобы работал Enter -->
    <div ref="editMail" tabindex="0">
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal';  // Компонент маленького модального вікна
import { regAPi } from '@/API.js';
const apiList = new regAPi();
export default {
  props: ['personEmail', 'personPassword'],
  components: {
    smallModal
  },
  data() {
    return {
      new_email: ''
    }
  },
  mounted() {
    // автофокус для дива
    this.$nextTick(() => {
      this.$refs.editMail.focus();
    });
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.personPassword ? this.editEmail() : this.goAddPass()
    );
  },
  methods: {
    // изменение почты
    // по апи сверяем, не т ли у нас такой почты в базе, если все ок, закрываем модалку и перекидываем введенную почту в родителя, а от туда в следующую модалку
    editEmail() {
      if (this.checkEmail) {
        apiList.checkAccount({ login: this.new_email }).then(resp => {
          if (resp.data.status == "done") {
            if (resp.data.data == 'login not found') {
              this.$emit('close');
              this.$emit('gopassword', { new_email: this.new_email })
            } else {
              window.say.messageError(this.lang['EmailAlreadyRegistered']);
            }
          } else if (resp.data.status == "error") {
            this.$emit('close');
            if (Array.isArray(resp.data.error)) {
              for (let key in resp.data.error) {
                window.say.messageError(resp.data.error[key]);
              }
            } else if (typeof resp.data.error == 'string') {
              window.say.messageError(resp.data.error);
            }
          } else {
            this.$emit('close');
            window.say.messageError("unknown error:0176");
          }
        })
      } else {
        window.say.messageError(this.lang['WrongFormat'])
      }
    },
    // ( костыль для модалки добавления пароля, обычный кейивэнт там не работает )(можно удалить после теста)
    // onKeyDown(event) {
    //     if (event.key === "Enter") {
    //         this.personPassword ? this.editEmail() : this.goAddPass()
    //     }
    // },
    // если юзер захотел поменять мыло, но он не додумался ранее создать пароль себе
    goAddPass() {
      this.$emit('close');
      this.$emit('goaddpass');
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang;
    },
    checkEmail() {
      const mailRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (mailRegular.test(this.new_email) == false) return false;
      else return true;
    },
  }
}
</script>

<style scoped>
.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00C279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

.center-text {
  text-align: center;
}

.grey-span {
  color: grey;
}
</style>